module.exports = __webpack_public_path__ + "user_top_bg.af33450e0ab229d1eb9b.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/assets/img/users/user_top_bg.png
// module id = ../../../../../src/assets/img/users/user_top_bg.png
// module chunks = 4